import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {QuestionnaireLimitModalComponent} from './questionnaire-limit-modal.component';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {FormsModule} from "@angular/forms";
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [QuestionnaireLimitModalComponent],
  imports: [
    CommonModule, FormsModule,
    AlertMessageModule,
    ButtonModule
  ],
  exports: [QuestionnaireLimitModalComponent]
})
export class QuestionnaireLimitModalModule { }
